import React from "react";

import { Theme, useTheme } from "@mui/material/styles";

import {
  SelectableChip,
  SelectableChipStyles,
  logDebug,
  mergeProperties,
} from "packable-components";
import { OrderStatusProps, ShippingStatus } from "./Order.types";
import { Badge } from "@mui/material";

const useStyles = (theme: Theme) => ({
  PackableSalectableChip: {
    muiSize: "small" as const,
  },
  OrderStatusContentStatusChipIconAttentionCountBadge: {
    muiColor: "error" as const,
  },
  OrderStatusContentStatusChipIconInfoCountBadge: {
    muiColor: "info" as const,
  },
});

export const OrderStatus: React.FC<OrderStatusProps> = (
  props
): React.JSX.Element => {
  const {
    status,
    isAdmin,
    label = status,
    count = 0,
    dispalyZeroCount = false,
    displayChipForZeroCount = false,
    disabled = false,
    styles,
  } = props;

  logDebug("OrderStatus PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useStyles(theme);
  const effectiveStyles =
    styles === undefined
      ? defaultStyles
      : mergeProperties(defaultStyles, styles);

  logDebug("OrderStatus effectiveStyles");
  logDebug(effectiveStyles);

  const attentionBadge = (status: ShippingStatus): boolean => {
    let rc = false;
    if (isAdmin) {
      switch (status) {
        case ShippingStatus.REQUESTED:
        case ShippingStatus.ACCEPTED:
        case ShippingStatus.CANCEL_REQUESTED:
        case ShippingStatus.PICKUP_REQUESTED:
          rc = true;
      }
    } else {
      switch (status) {
        case ShippingStatus.LABELS_SHIPPED:
        case ShippingStatus.LABELS_DELIVERED:
          rc = true;
      }
    }
    return rc;
  };

  const chipColor = (status: ShippingStatus): string => {
    let color = "white";
    if (disabled) return color;
    switch (status) {
      case ShippingStatus.REQUESTED:
        color = "mustard";
        break;
      case ShippingStatus.REJECTED:
        color = "red";
        break;
      case ShippingStatus.PICKUP_REJECTED:
        color = "red";
        break;
      case ShippingStatus.ACCEPTED:
        color = "yellow";
        break;
      case ShippingStatus.CANCEL_REQUESTED:
        color = "orange";
        break;
      case ShippingStatus.CANCELLED:
        color = "coral";
        break;
      case ShippingStatus.LABELS_SHIPPED:
        color = "blue";
        break;
      case ShippingStatus.LABELS_DELIVERED:
        color = "lime";
        break;
      case ShippingStatus.PICKUP_REQUESTED:
        color = "pink";
        break;
      case ShippingStatus.PICKUP_SCHEDULED:
        color = "blue";
        break;
      case ShippingStatus.PICKUP_COMPLETED:
        color = "green";
        break;
      case ShippingStatus.DELIVERED:
        color = "darkgreen";
        break;
    }
    return color;
  };

  return (
    <>
      {count === 0 && !displayChipForZeroCount ? (
        <></>
      ) : (
        <div>
          {count > 0 || (count == 0 && dispalyZeroCount) ? (
            <Badge
              className={
                attentionBadge(status)
                  ? "OrderStatusContentStatusChipIconAttentionCountBadge"
                  : "OrderStatusContentStatusChipIconInfoCountBadge"
              }
              sx={
                attentionBadge(status)
                  ? effectiveStyles.OrderStatusContentStatusChipIconAttentionCountBadge
                  : effectiveStyles.OrderStatusContentStatusChipIconInfoCountBadge
              }
              badgeContent={count}
              color={
                attentionBadge(status)
                  ? effectiveStyles
                      .OrderStatusContentStatusChipIconAttentionCountBadge
                      .muiColor
                  : effectiveStyles
                      .OrderStatusContentStatusChipIconInfoCountBadge.muiColor
              }
            >
              <SelectableChip
                styles={effectiveStyles}
                label={label}
                description={label}
                color={chipColor(status)}
                selected
                selectableChipStyle={
                  SelectableChipStyles[
                    chipColor(status) as keyof typeof SelectableChipStyles
                  ]
                }
              />
            </Badge>
          ) : (
            <SelectableChip
              styles={effectiveStyles}
              label={label}
              description={label}
              color={chipColor(status)}
              selected
              selectableChipStyle={
                SelectableChipStyles[
                  chipColor(status) as keyof typeof SelectableChipStyles
                ]
              }
            />
          )}
        </div>
      )}
    </>
  );
};

export default OrderStatus;
